import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.75 11.408v5.387c0 1.575-.182 2.862-1.023 3.693-.837.829-2.131 1.008-3.723 1.008H5.997c-1.591.004-2.885-.172-3.724-1-.841-.83-1.023-2.117-1.023-3.692V9.406c0-1.576.182-2.863 1.023-3.694.837-.828 2.131-1.007 3.723-1.007h7.334c-.403.435-.73.942-.958 1.5H5.996c-1.604 0-2.307.216-2.669.574-.354.35-.572 1.027-.577 2.571h9.408c.139.541.366 1.046.665 1.5H2.75v5.954c0 1.583.219 2.272.577 2.625.36.356 1.063.571 2.667.567h10.01c1.604 0 2.307-.217 2.669-.575.358-.354.577-1.043.577-2.626v-4.228a5 5 0 0 0 1.5-1.16",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M5.6 17.155h1.8M9.65 17.155h3.6"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17 3a5 5 0 1 1 0 10 5 5 0 0 1 0-10",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".4",
      d: "M18.098 10.31a.4.4 0 0 1-.253-.071.6.6 0 0 1-.143-.175l-.837-1.259a1 1 0 0 0-.317-.33.84.84 0 0 0-.435-.098h-.694q-.279 0-.279-.272 0-.266.28-.266h1.063q.466 0 .72-.162a.72.72 0 0 0 .318-.506H15.4q-.26 0-.26-.24 0-.234.26-.234h2.095q-.175-.532-.973-.532H15.4q-.26 0-.26-.24 0-.233.26-.233h3.19q.267 0 .267.233 0 .24-.266.24h-.733a.97.97 0 0 1 .305.532h.428q.266 0 .266.234 0 .24-.266.24h-.402q-.045.46-.344.759-.292.298-.798.382.337.085.61.493l.688 1.032q.11.176.038.324-.07.15-.285.15Z"
    }, null, -1)
  ]))]))
}
export default { render: render }